import React, { useState, useEffect } from 'react';
import ModernSidebar from './ModernSidebar';
import TopNavBar from './TopNavBar';
import { useAuth } from '../context/AuthContext';

const ModernLayout = ({ children }) => {
  const { user } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Load sidebar state from localStorage and sync with sidebar
  useEffect(() => {
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null) {
      setSidebarCollapsed(JSON.parse(savedState));
    }

    // Listen for storage changes to sync across components
    const handleStorageChange = () => {
      const newState = localStorage.getItem('sidebarCollapsed');
      if (newState !== null) {
        setSidebarCollapsed(JSON.parse(newState));
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Also listen for custom event from sidebar
    const handleSidebarToggle = (e) => {
      setSidebarCollapsed(e.detail);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('sidebarToggle', handleSidebarToggle);
    };
  }, []);

  const toggleSidebar = () => {
    const newState = !sidebarCollapsed;
    setSidebarCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState));
    // Dispatch custom event for sidebar to listen
    window.dispatchEvent(new CustomEvent('sidebarToggle', { detail: newState }));
  };

  return (
    <div className="min-h-screen bg-[#F6F8F5]">
      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <ModernSidebar
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      {/* Main Content Container - with left margin for fixed sidebar on desktop */}
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        }`}>
        {/* Top Navigation */}
        <TopNavBar
          toggleSidebar={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        {/* Main Content */}
        <main
          className="flex-1"
          style={{
            paddingTop: user?.isSandbox ? 'calc(64px + var(--sandbox-banner-height))' : '64px'
          }}
        >
          <div className="p-6">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default ModernLayout;

